(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["watsons-store-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWatsonsFinder(root) {
    (root || document).querySelectorAll('[data-watsons-store-finder]').forEach(function (finder) {
      if (finder.dataset.storeFinderReady === 'true') return;
      finder.dataset.storeFinderReady = 'true';
      var pageSize = 20;
      var buttons = Array.from(finder.querySelectorAll('.watsons-store-finder__item'));
      var search = finder.querySelector('[data-store-search]');
      var region = finder.querySelector('[data-store-region]');
      var city = finder.querySelector('[data-store-city]');
      var service = finder.querySelector('[data-store-service]');
      var count = finder.querySelector('[data-store-count]');
      var pagination = finder.querySelector('[data-store-pagination]');
      var name = finder.querySelector('[data-store-name]');
      var address = finder.querySelector('[data-store-address]');
      var hours = finder.querySelectorAll('[data-store-hours-copy]');
      var map = finder.querySelector('[data-store-map]');
      var detailNumber = finder.querySelector('[data-store-detail-number]');
      var currentPage = 1;
      var visible = buttons.slice();

      Array.from(new Set(buttons.map(function (button) { return button.dataset.city; }))).sort().forEach(function (cityName) {
        if (!cityName) return;
        var option = document.createElement('option');
        option.value = cityName;
        option.textContent = cityName;
        city.appendChild(option);
      });

      function selectStore(button) {
        buttons.forEach(function (item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        name.textContent = button.dataset.name;
        address.textContent = button.dataset.address;
        hours.forEach(function (item) { item.textContent = button.dataset.hours; });
        detailNumber.textContent = button.dataset.storeIndex;
        map.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(button.dataset.coordinates) + '&z=15&output=embed';
      }

      function renderPagination(totalPages) {
        pagination.innerHTML = '';
        if (totalPages <= 1) return;
        function add(label, page, active) {
          var button = document.createElement('button');
          button.type = 'button';
          button.textContent = label;
          button.classList.toggle('is-active', Boolean(active));
          button.addEventListener('click', function () {
            currentPage = page;
            applyFilters(false);
          });
          pagination.appendChild(button);
        }
        add('<', Math.max(1, currentPage - 1), false);
        for (var i = 1; i <= totalPages; i += 1) add(String(i), i, i === currentPage);
        add('>', Math.min(totalPages, currentPage + 1), false);
      }

      function applyFilters(resetPage) {
        if (resetPage !== false) currentPage = 1;
        var query = search.value.trim().toLowerCase();
        visible = buttons.filter(function (button) {
          var text = (button.dataset.name + ' ' + button.dataset.address + ' ' + button.dataset.city).toLowerCase();
          return (!query || text.indexOf(query) !== -1) && (!region.value || button.dataset.region === region.value) && (!city.value || button.dataset.city === city.value) && (!service.value || button.dataset.service === service.value);
        });
        count.textContent = String(visible.length);
        var totalPages = Math.max(1, Math.ceil(visible.length / pageSize));
        currentPage = Math.min(currentPage, totalPages);
        var start = (currentPage - 1) * pageSize;
        buttons.forEach(function (button) { button.hidden = true; });
        visible.slice(start, start + pageSize).forEach(function (button) { button.hidden = false; });
        renderPagination(totalPages);
        var currentActive = finder.querySelector('.watsons-store-finder__item.is-active');
        var active = visible.indexOf(currentActive) !== -1 ? currentActive : visible[0];
        if (active) selectStore(active);
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          if (event.target.closest('a')) return;
          selectStore(button);
        });
        button.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          selectStore(button);
        });
      });
      [search, region, city, service].forEach(function (control) {
        control.addEventListener('input', function () { applyFilters(true); });
        control.addEventListener('change', function () { applyFilters(true); });
      });
      finder.querySelector('[data-use-location]').addEventListener('click', function () {
        search.value = '';
        region.value = '';
        city.value = '';
        service.value = '';
        applyFilters(true);
      });
      finder.querySelector('.watsons-store-finder__close').addEventListener('click', function () {
        finder.querySelector('.watsons-store-finder__details').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      applyFilters(true);
    });
  }
  window.SINGCHOICE_INIT_WATSONS_FINDER = initWatsonsFinder;
  initWatsonsFinder(document);
})();

  } catch(e) { console.error(e); }
})();
})();
